import { Icon as Iconify } from '@iconify/react';
import { useEffect, useState } from 'react';
import { Popover } from '@mui/material';
import { InputNumber } from './inputFields';
import { LionColorPicker } from '../components/lionColorPicker';

export const CssBorderManager = (props) => {
    const [borderStyle, setBorderStyle] = useState(undefined) //{borderWidth: 1, borderColor: "#999", borderStyle: "solid"} only using "solid" and "none"
    const [anchorEl, setAnchorEl] = useState(null);
    const openSettings = Boolean(anchorEl);

    useEffect(() => {
        if (props.value) {
            const bStyle = getBorderStyle(props.value)
            setBorderStyle(bStyle)
        }
    }, [props.value])

    const getBorderStyle = (borderStr) => {
    if (borderStr) {
        try {
            const valParts = borderStr.split(' ')
            const bWidth = parseInt(valParts[0].replace("px",""))
            const bStyle = valParts[1]
            const bColor = valParts[2]
            return {borderWidth: bWidth, borderColor: bColor, borderStyle: bStyle}
        }
        catch(e) {return undefined}

    }
        else return undefined
    }

    const getPrettyValue = (borderStyle) => {
        if (borderStyle) {
            if (borderStyle.borderWidth === 0) return "No border"

            return <div className='flex flex-row items-center'>
                <div>Width: {borderStyle.borderWidth}px, Color: </div>
                <div style={{backgroundColor: borderStyle.borderColor}} className='w-6 h-6 ml-1 border border-black rounded'></div>
                <div className='text-xs'>({borderStyle.borderColor})</div>
                </div>
        }
        else return "No Border"
    }
  const handleOpenDialogSettings = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseDialogSettings = () => {
    setAnchorEl(null);
  };
  const updateBorderProp = (propName, propValue) => {
    const newSettings = {...borderStyle, [propName]: propValue}
    //if (borderStyle.borderColor === propValue) return
    if (props.onChange) {
        props.onChange(`${newSettings.borderWidth}px ${newSettings.borderWidth > 0 ? "solid" : "none"} ${newSettings.borderColor}`)
    }
  }

    return <div>
                <div className={`block text-sm font-medium leading-6 text-gray-900`}>
                {props.displayName}
                </div>
                <div className="flex flex-row items-center border rounded w-[280px]">
                    <div className=" rounded-s bg-gray-100 w-[240px] h-[42px] p-2">
                        {getPrettyValue(borderStyle)}
                    </div>
                    <div className='flex items-center justify-center w-[40px] h-[42px] hover:cursor-pointer hover:bg-slate-200'
                        onClick={handleOpenDialogSettings}
                    >
                        <Iconify icon="lucide:ellipsis" />
                    </div>
                </div>
        <Popover
            open={openSettings}
            anchorEl={anchorEl}
            onClose={handleCloseDialogSettings}
            anchorOrigin={{
                vertical: 'top',
                }}
            >
                {borderStyle && <div className='w-[800px] max-h-[600px] p-3'>
                    <div className='flex flex-row items-end gap-x-16'>
                        <div className='mt-2 w-56'>
                            <InputNumber displayName="Border width (px)"
                            min={0} max={100} incr={1}
                            onChange={(val) => updateBorderProp("borderWidth", val)}
                            value={borderStyle.borderWidth}
                            />
                        </div>
                        <div>
                            <div className={`block text-sm font-medium leading-6 text-gray-900`}>
                            Border Colour
                            </div>
                            <LionColorPicker color={borderStyle.borderColor}
                                onChange={(color) => updateBorderProp('borderColor', color)}
                            />
                        </div>

                    </div>
                    
                </div>

                
                }
        </Popover>

    </div>
}